import {isSubscribed} from "./base/conditions";

export default () => {
    if (!isSubscribed()) {
        return {name: 'get-started'};
    }
    return null;
};

